import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftsStatuses';
import block from 'propmods';

import { AliceApp } from '../../model/skill';

import './Statuses.scss';

const t = i18n(keyset);

interface StatusProps {
    aliceApp: AliceApp;
}

const b = block('DeploymentStatus');

const labels = {
    active: t('dialog-published'),
    inactive: t('dialog-not-published'),
};

export default function DeploymentStatus({ aliceApp }: StatusProps) {
    const status = aliceApp.onAir ? 'active' : 'inactive';
    const label = labels[status];

    return <div {...b({ active: aliceApp.onAir })}>{label}</div>;
}
